import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Effect({ color = 'icon.white', ...props }) {
  return (
    <IconBase viewBox='0 0 18 18' {...props}>
      <Path
        d='
            M 5.98131 3.48181
            C 6.15446 3.01388 6.81629 3.01388 6.98944 3.4818
            L 8.21417 6.79158
            C 8.26861 6.9387 8.3846 7.05469 8.53171 7.10913
            L 11.8415 8.33385
            C 12.3094 8.507 12.3094 9.16883 11.8415 9.34198
            L 8.53171 10.5667
            C 8.3846 10.6211 8.26861 10.7371 8.21417 10.8843
            L 6.98944 14.194
            C 6.81629 14.662 6.15446 14.662 5.98131 14.194
            L 4.75659 10.8843
            C 4.70215 10.7371 4.58616 10.6211 4.43904 10.5667
            L 1.12927 9.34198
            C 0.661339 9.16883 0.661338 8.507 1.12927 8.33385
            L 4.43904 7.10913
            C 4.58616 7.05469 4.70215 6.9387 4.75659 6.79158
            L 5.98131 3.48181
            Z
          '
        fill={color}
      />
      <Path
        d='
            M 11.8123 1.16757
            C 11.9191 0.879039 12.3272 0.879039 12.4339 1.16757
            L 12.7459 2.01061
            C 12.7795 2.10132 12.851 2.17285 12.9417 2.20641
            L 13.7847 2.51837
            C 14.0733 2.62513 14.0733 3.03323 13.7847 3.13999
            L 12.9417 3.45195
            C 12.851 3.48551 12.7795 3.55703 12.7459 3.64775
            L 12.4339 4.49079
            C 12.3272 4.77932 11.9191 4.77932 11.8123 4.49079
            L 11.5004 3.64775
            C 11.4668 3.55703 11.3953 3.48551 11.3046 3.45195
            L 10.4615 3.13999
            C 10.173 3.03323 10.173 2.62513 10.4615 2.51837
            L 11.3046 2.20641
            C 11.3953 2.17285 11.4668 2.10132 11.5004 2.01061
            L 11.8123 1.16757
            Z
          '
        fill={color}
      />
      <Path
        d='
            M 12.0478 13.0115
            C 12.1055 12.8555 12.3261 12.8555 12.3838 13.0115
            L 12.5626 13.4946
            C 12.5807 13.5437 12.6194 13.5823 12.6684 13.6005
            L 13.1515 13.7792
            C 13.3075 13.8369 13.3075 14.0575 13.1515 14.1152
            L 12.6684 14.294
            C 12.6194 14.3122 12.5807 14.3508 12.5626 14.3998
            L 12.3838 14.883
            C 12.3261 15.0389 12.1055 15.0389 12.0478 14.883
            L 11.869 14.3998
            C 11.8509 14.3508 11.8122 14.3122 11.7632 14.294
            L 11.2801 14.1152
            C 11.1241 14.0575 11.1241 13.8369 11.2801 13.7792
            L 11.7632 13.6005
            C 11.8122 13.5823 11.8509 13.5437 11.869 13.4946
            L 12.0478 13.0115
            Z
          '
        fill={color}
      />
    </IconBase>
  )
}

Effect.propTypes = {
  color: PropTypes.string,
}

export default Effect
